/**
 * MM Products Upload
 * File download via fetch blob (cross-origin workaround)
 * Read more/less: label shown only when description is actually clamped
 */
(function () {
	if (window.__mmProductsUploadInit) return;
	window.__mmProductsUploadInit = true;

	var INIT_FLAG = 'mmProductsUploadBound';

	function updateClampState(wrapper) {
		if (!wrapper) return;
		var description = wrapper.querySelector('.mm-products-upload__description');
		if (!description) return;
		if (wrapper.classList.contains('is-expanded')) {
			wrapper.classList.add('is-clamped');
			return;
		}
		var overflows = description.scrollHeight - description.clientHeight > 1;
		wrapper.classList.toggle('is-clamped', overflows);
	}

	function initSection(section) {
		if (section.dataset[INIT_FLAG]) return;
		section.dataset[INIT_FLAG] = 'true';

		var wrapper = section.querySelector('[data-products-upload-readmore]');
		var readMoreBtn = section.querySelector('[data-products-upload-readmore-btn]');

		if (wrapper) {
			requestAnimationFrame(function () { updateClampState(wrapper); });
			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(function () { updateClampState(wrapper); });
			}
			window.addEventListener('resize', function () { updateClampState(wrapper); });
		}

		if (readMoreBtn && wrapper) {
			readMoreBtn.addEventListener('click', function () {
				var next = !wrapper.classList.contains('is-expanded');
				wrapper.classList.toggle('is-expanded', next);
				readMoreBtn.setAttribute('aria-expanded', next ? 'true' : 'false');
			});
		}

		section.querySelectorAll('[data-download-url]').forEach(function (dl) {
			dl.addEventListener('click', function () {
				var url = dl.dataset.downloadUrl;
				if (!url) return;
				fetch(url)
					.then(function (r) { return r.blob(); })
					.then(function (blob) {
						var a = document.createElement('a');
						a.href = URL.createObjectURL(blob);
						a.download = dl.dataset.downloadName || 'document.pdf';
						document.body.appendChild(a);
						a.click();
						a.remove();
						URL.revokeObjectURL(a.href);
					});
			});
		});
	}

	function initAll() {
		document.querySelectorAll('[data-products-upload]').forEach(initSection);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}
})();
